import React, { useEffect, useState } from 'react';
import '../styles/components/Loader.scss';

const Loader = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Add a class to the body to prevent scrolling during loading
        document.body.classList.add('loading');

        // Simulate loading time (you'd replace this with actual loading logic)
        const timer = setTimeout(() => {
            setIsLoading(false);
            document.body.classList.remove('loading');
        }, 2500);

        return () => {
            clearTimeout(timer);
            document.body.classList.remove('loading');
        };
    }, []);

    if (!isLoading) return null;

    return (
        <div className={`loader-container ${isLoading ? 'active' : 'fade-out'}`}>
            <div className="loader-content">
                <svg className="owl-loader" viewBox="0 0 200 200">
                    <path
                        className="owl-body"
                        d="M100,30 C130,30 150,60 150,110 C150,160 130,180 100,180 C70,180 50,160 50,110 C50,60 70,30 100,30 Z"
                    />

                    <circle className="left-eye" cx="75" cy="90" r="15" />
                    <circle className="right-eye" cx="125" cy="90" r="15" />

                    <circle className="left-pupil" cx="75" cy="90" r="7" />
                    <circle className="right-pupil" cx="125" cy="90" r="7" />

                    <path
                        className="beak"
                        d="M90,110 L100,125 L110,110 Z"
                    />
                </svg>

                <div className="loading-text">
                    <span>L</span>
                    <span>o</span>
                    <span>a</span>
                    <span>d</span>
                    <span>i</span>
                    <span>n</span>
                    <span>g</span>
                    <span>.</span>
                    <span>.</span>
                    <span>.</span>
                </div>
            </div>
        </div>
    );
};

export default Loader;